import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentStepSelector, formSummarySelector } from '../../../store/modules/steps/selectors';
import { FormStep, FormStepProps, StepsState } from '../../../model/global';
import CustomFormField from '../../FormControls/CustomFormField';
import { getFormControlInitialState } from '../../utils';
import { CustomFormFieldState } from '../../FormControls/CustomFormField/CustomFormField';
import { stepsActions } from '../../../store/modules/steps/reducer';


const MainEnquiry: React.FC<FormStepProps> = ({ onStepControlsChange, data: { stepTemplate } }) => {

	const dispatch = useDispatch()
	const step = useSelector(currentStepSelector) as FormStep<'main'>
	const summary = useSelector(formSummarySelector) as StepsState['formSummary']
	const stepErrors = summary.validationErrors[step.stepTemplate];

	const fields: {
		enquiryTopic: CustomFormFieldState | undefined,
		targetGroup: CustomFormFieldState | undefined,
	} = useMemo(
		() => {
			return {
				enquiryTopic: getFormControlInitialState('enquiry_topic', step.stepData.fields.main),
				targetGroup: getFormControlInitialState('target_group', step.stepData.fields.main),
			}
		},
		[step.stepData.fields.main]
	);

	// initialise the step data once
	useEffect(() => {
		// don't re-init fields
		if (summary.initialized[stepTemplate]) return;

		const initialData: Record<string, CustomFormFieldState> = {};

		// fill in state with initial field values and validity
		for (const [key, element] of Object.entries(fields)) {
			if (!element || !element.name) continue;

			const invalid = element.value === '' && element.required === true
			initialData[element.name] = {
				name: element.name as string,
				originalField: element.originalField,
				value: element.value,
				required: !!element.required,
				valid: !invalid,
				invalidReason: element.invalidReason || '',
			};
		}

		dispatch(stepsActions.initializeStepPayloadValues({
			stepTemplate,
			stepPayload: initialData,
			initialize: true,
		}));


	}, [dispatch, fields, stepTemplate, summary.initialized]);

	const fieldChangeHandler = (event: CustomFormFieldState): void => {
		dispatch(stepsActions.updateStepPayloadValues({
			stepTemplate,
			stepPayload: event,
		}));
	}

	if (!step) return null
	const enquiryTopic = summary.steps[stepTemplate]['enquiry_topic']
		? summary.steps[stepTemplate]['enquiry_topic']
		: undefined;
	const targetGroup = summary.steps[stepTemplate]['target_group']
		? summary.steps[stepTemplate]['target_group']
		: undefined;

	const attributeOBJ = (item: any) => {
		return ({
			field: item,
			fieldErrors: stepErrors,
			onFieldChange: (e: any) => fieldChangeHandler(e)
		})
	}

	return (
		<div className='uk-grid-medium uk-grid uk-grid-stack'>
			{/* Two select boxes like on here: https://www.wolf.eu/service/kundendienstbeauftragung/ */}
			{enquiryTopic && <CustomFormField  {...attributeOBJ(enquiryTopic)} />}
			{targetGroup && <CustomFormField {...attributeOBJ(targetGroup)} />}
		</div>
	);
};

export default memo(MainEnquiry);
